import { render, staticRenderFns } from "./supplyOrder.vue?vue&type=template&id=1641187c&scoped=true"
import script from "./supplyOrder.vue?vue&type=script&lang=js"
export * from "./supplyOrder.vue?vue&type=script&lang=js"
import style0 from "./supplyOrder.vue?vue&type=style&index=0&id=1641187c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1641187c",
  null
  
)

export default component.exports